import { APICLIENT } from "../shared";

export const getStateList = async () => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get("/StateMaster/StateList");
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};
